const json = {
    GE: {
        All: 'ყველა',
        'Wine Almighty': 'პირველი ღვინო',
        'Tipsy Adventure': 'ღვინო ყველგან',
        'Tradition of Supra': 'ქართული სუფრა',
        'Colorful Cuisine': 'ფერადი სამზარეულო',
        History: 'ისტორია',
        Culture: 'კულტურა',
        Architecture: 'არქიტექტურა',
        Tbilisi: 'თბილისი',
        Highlands: 'მთები',
        'Ski Resorts': 'ზამთრის კურორტები',
        'Black Sea': 'შავი ზღვა',
        Nature: 'ბუნება',
        Adventure: 'თავგადასავლები',
        ყველა: 'All',
        'პირველი ღვინო': 'Wine Almighty',
        'ღვინო ყველგან': 'Tipsy Adventure',
        'ქართული სუფრა': 'Tradition of Supra',
        'ფერადი სამზარეულო': 'Colorful Cuisine',
        ისტორია: 'History',
        კულტურა: 'Culture',
        არქიტექტურა: 'Architecture',
        თბილისი: 'Tbilisi',
        მთები: 'Highlands',
        'ზამთრის კურორტები': 'Ski Resorts',
        'შავი ზღვა': 'Black Sea',
        ბუნება: 'Nature',
        თავგადასავლები: 'Adventure',
        CHOOSE_CATEGORY: 'აირჩიეთ კატეგორია',
        CLEAR_FILTER: 'წაშლა'
    },
    EN: {
        All: 'All',
        'Wine Almighty': 'Wine Almighty',
        'Tipsy Adventure': 'Tipsy Adventure',
        'Tradition of Supra': 'Tradition of Supra',
        'Colorful Cuisine': 'Colorful Cuisine',
        History: 'History',
        Culture: 'Culture',
        Architecture: 'Architecture',
        Tbilisi: 'Tbilisi',
        Highlands: 'Highlands',
        'Ski Resorts': 'Ski Resorts',
        'Black Sea': 'Black Sea',
        Nature: 'Nature',
        Adventure: 'Adventure',
        ყველა: 'All',
        'პირველი ღვინო': 'Wine Almighty',
        'ღვინო ყველგან': 'Tipsy Adventure',
        'ქართული სუფრა': 'Tradition of Supra',
        'ფერადი სამზარეულო': 'Colorful Cuisine',
        ისტორია: 'History',
        კულტურა: 'Culture',
        არქიტექტურა: 'Architecture',
        თბილისი: 'Tbilisi',
        მთები: 'Highlands',
        'ზამთრის კურორტები': 'Ski Resorts',
        'შავი ზღვა': 'Black Sea',
        ბუნება: 'Nature',
        თავგადასავლები: 'Adventure',
        CHOOSE_CATEGORY: 'Choose Category',
        CLEAR_FILTER: 'Clear filter'
    }
}

export default json



// WEBPACK FOOTER //
// ./client/app/components/home/sidebar/categories/categories.texts.js